import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "app/App";
import AppProviders from "app/providers/AppProviders";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>
);

reportWebVitals();
